import { useAtomValue } from 'jotai';
import { seriesAtom } from '../atoms/seriesAtoms';

const useSeries = () => {
    const series = useAtomValue(seriesAtom);
    return [...series].sort((a, b) => (a.name || '').localeCompare(b.name || ''));
};

export default useSeries;
